module.exports = __webpack_public_path__ + "static/media/va.d6ee6901.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/va.svg
// module id = 281
// module chunks = 0